import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class MachineSaveNodeNameHandler {
  saveNodeName(node: OurNode, nodeInputValue: string) {
    const machineStructureNodeset = getMachineStructureNodeset();
    node.name = nodeInputValue;
    const singleRootNode = node.returnRootNodeFromOurNode();
    machineStructureNodeset.setRootNode(singleRootNode);
    const flatMap = singleRootNode.createMapFromOurNodeTree();
    machineStructureNodeset.setFlatMap(flatMap);
  }
}
